import { useMutation } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { useState, useCallback } from "react";

const useParcelSearch = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const [successMessage, setSuccessMessage] = useState(null);

  const searchParcelAPI = async (parcelId) => {
    if (!parcelId || parcelId.trim() === "") {
      throw new Error("Please enter a parcel ID");
    }

    let headers = {};
    if (isAuthenticated) {
      const token = await getAccessTokenSilently();
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await axios.get(
        `${
          process.env.REACT_APP_ENDPOINT
        }/api/public-map/parcel-search/${encodeURIComponent(parcelId.trim())}`,
        { headers }
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        throw new Error("Parcel not found");
      } else if (error.response?.status === 400) {
        throw new Error("Invalid parcel ID");
      } else {
        throw new Error("Failed to search");
      }
    }
  };

  const mutation = useMutation(searchParcelAPI, {
    onSuccess: () => {
      setSuccessMessage(`Flying to location...`);
    },
    onError: () => {
      setSuccessMessage(null);
    },
  });

  const searchParcel = useCallback(
    (parcelId) => {
      setSuccessMessage(null);
      return mutation.mutateAsync(parcelId);
    },
    [mutation]
  );

  const clearMessages = useCallback(() => {
    setSuccessMessage(null);
    mutation.reset();
  }, [mutation]);

  return {
    searchParcel,
    isLoading: mutation.isLoading,
    error: mutation.error?.message,
    successMessage,
    clearMessages,
  };
};

export default useParcelSearch;
